import { Appliance } from '@common/util-models';
import { createAction, props } from '@ngrx/store';

export const loadAppliances = createAction('[Catalog] Load appliances');

export const loadAppliancesSuccess = createAction(
  '[Catalog] Appliances loaded successfully',
  props<{ appliances: Appliance[] }>()
);

export const loadAppliancesFailure = createAction(
  '[Catalog] Load appliances failed',
  props<{ error: Error }>()
);

export const selectSkyBox = createAction(
  '[Catalog] Select Sky box',
  props<{ appliance: Appliance }>()
);
